import { useTranslation } from 'react-i18next';
import { IMG_PATH } from 'constants/config';

const data = [
  {
    title: '隨時取消訂閱',
    text: ['使用不滿意，隨時可取消訂閱，彈性取消'],
  },
  {
    title: '交易資訊不外露',
    text: ['使用全球最大金流服務公司Stripe，作為第三方支付，保證交易資訊不外露'],
  },
  {
    title: '保證退款',
    text: ['使用不如預期，隨時可以取消'],
  },
];

const img = `${IMG_PATH}/promise`;

function ThreePromise() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-12 text-white" style={{ background: '#e4ad22' }}>
      <div className="text-4xl mb-12">{t('三大保證')}</div>

      <div className="w-full space-y-8 sm:space-y-0 sm:space-x-8 sm:flex justify-around">
        {data.map(({ title, text }, index) => (
          <div key={index} className="flex flex-col items-center sm:w-1/5">
            <img src={`${img}${index}.png`} alt="" />

            <div className="text-lg font-bold my-8">{t(title)}</div>

            <div className="w-3/5 text-center sm:w-full sm:space-y-6">
              {text.map((str) => (
                <div key={str}>{t(str)}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThreePromise;
